import { createRoute } from '@tanstack/react-router';
import { rootRoute } from 'routes/rootRoute';
import { zodPathParamId } from 'routes/routeUtils';
import { z } from 'zod';

export const attachDigiAccountingDocumentRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: '/redirect/digipharmacie/trades/participation/$participationId/attach-accounting-document',
  params: z.object({ participationId: zodPathParamId }),
  validateSearch: z.object({
    documentId: z.coerce.string(),
    documentDownloadUrl: z.string(),
  }),
}).lazy(() =>
  import('pages/pharmacy/Trades/AttachAccountingDocument/AttachAccountingDocumentPage').then(
    (d) => d.Route
  )
);
